import { applyMiddleware, createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import promise from "redux-promise-middleware";
import thunk from "redux-thunk";
import ErrorMiddleware from "../middlewares/errorMiddleware";
import rootReducer from "../reducer/reducers";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "versionState"],
};

const middleware = [thunk, ErrorMiddleware, promise];

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  persistedReducer,
  applyMiddleware(...middleware)
);

export const persistor = persistStore(store);
